/* 私有路由表 */
export const privateRoutes = [
  {
    path: '/',
    name: 'publicShell',
    meta: {
      title: '首页',
      requiresAuth: false,
    },
    // 重定向
    redirect() {
      return '/calculationResult';
    },
    component: () => import('@/components/publicShell.vue'),
    children: [
      // ----------------------------------- 权限管理 -----------------------------------

      // 菜单管理
      {
        path: '/menuManagement',
        name: 'MenuManagement',
        component: () => import('@/views/authorityManagement/menuManagement.vue'),
        meta: {
          title: '权限管理 - 菜单管理',
          requiresAuth: true,
        },
      },
      // 角色管理
      {
        path: '/roleManagement',
        name: 'RoleManagement',
        component: () => import('@/views/authorityManagement/roleManagement.vue'),
        meta: {
          title: '权限管理 - 角色管理',
          requiresAuth: true,
        },
      },
      // 用户管理
      {
        path: '/userManagement',
        name: 'UserManagement',
        component: () => import('@/views/authorityManagement/userManagement.vue'),
        meta: {
          title: '权限管理 - 用户管理',
          requiresAuth: true,
        },
      },

      // ----------------------------------- 科学计算 -----------------------------------

      // 科学计算 - 注脂计算
      {
        path: '/calculationResult',
        name: 'CalculationResult',
        component: () => import('@/views/greaseCalculation/calculationResult.vue'),
        meta: {
          title: '科学计算 - 注脂计算',
          requiresAuth: false,
        },
      },

      // 科学计算 - 轴承类别管理
      {
        path: '/bearingTypeManagement',
        name: 'BearingTypeManagement',
        component: () => import('@/views/greaseCalculation/bearingTypeManagement.vue'),
        meta: {
          title: '科学计算 - 轴承类别管理',
          requiresAuth: true,
        },
      },

      // ----------------------------------- 系统管理 -----------------------------------

      // 系统管理 - 区域管理
      {
        path: '/regionManagement',
        name: 'RegionManagement',
        component: () => import('@/views/systemManagement/regionManagement.vue'),
        meta: {
          title: '系统管理 - 区域管理',
          requiresAuth: true,
        },
      },
      // 系统管理 - 设备管理
      {
        path: '/deviceManagement',
        name: 'deviceManagement',
        component: () => import('@/views/systemManagement/deviceManagement.vue'),
        meta: {
          title: '系统管理 - 设备管理',
          requiresAuth: true,
        },
      },
      // 系统管理 - 库存管理
      {
        path: '/inventoryManagement',
        name: 'inventoryManagement',
        component: () => import('@/views/systemManagement/inventoryManagement.vue'),
        meta: {
          title: '系统管理 - 库存管理',
          requiresAuth: true,
        },
      },
      // 系统管理 - 推送管理
      {
        path: '/pushManagement',
        name: 'pushManagement',
        component: () => import('@/views/systemManagement/pushManagement.vue'),
        meta: {
          title: '系统管理 - 推送管理',
          requiresAuth: true,
        },
      },
      // 系统管理 - 网络模式管理
      {
        path: '/networkModeManagement',
        name: 'networkModeManagement',
        component: () => import('@/views/systemManagement/networkModeManagement.vue'),
        meta: {
          title: '系统管理 - 网络模式管理',
          requiresAuth: true,
        },
      },
      // 系统管理 - 设备型号管理
      {
        path: '/deviceModelManagement',
        name: 'deviceModelManagement',
        component: () => import('@/views/systemManagement/deviceModelManagement.vue'),
        meta: {
          title: '系统管理 - 设备型号管理',
          requiresAuth: true,
        },
      },

      // ----------------------------------- 文章管理 -----------------------------------

      // 文章管理 - 新闻资讯
      {
        path: '/newsManagement',
        name: 'NewsManagement',
        component: () => import('@/views/newsManagement/newsManagement.vue'),
        meta: {
          title: '文章管理 - 新闻资讯',
          requiresAuth: true,
        },
      },
      // 文章管理 - 发布文章
      {
        path: '/publishNews',
        name: 'publishNews',
        component: () => import('@/views/newsManagement/publishNews.vue'),
        meta: {
          title: '文章管理 - 发布文章',
          requiresAuth: true,
        },
      },
      // 文章管理 - 留言管理
      {
        path: '/messageManagement',
        name: 'messageManagement',
        component: () => import('@/views/newsManagement/messageManagement.vue'),
        meta: {
          title: '文章管理 - 留言管理',
          requiresAuth: true,
        },
      },

      // ----------------------------------- 官网管理 -----------------------------------

      // 官网管理 - 资料下载管理
      {
        path: '/fileDownloadManagement',
        name: 'fileDownloadManagement',
        component: () => import('@/views/officialWebsiteManagement/fileDownloadManagement.vue'),
        meta: {
          title: '官网管理 - 资料下载管理',
          requiresAuth: true,
        },
      },
      // 官网管理 - 招贤纳士管理
      {
        path: '/recruitRightPersonManagement',
        name: 'recruitRightPersonManagement',
        component: () => import('@/views/officialWebsiteManagement/recruitRightPersonManagement.vue'),
        meta: {
          title: '官网管理 - 招贤纳士管理',
          requiresAuth: true,
        },
      },

      // ----------------------------------- 异常管理 -----------------------------------

      // 异常管理 - 异常数据汇总
      {
        path: '/abnormalDataCollection',
        name: 'abnormalDataCollection',
        component: () => import('@/views/anomalyManagement/abnormalDataCollection.vue'),
        meta: {
          title: '异常管理 - 异常数据汇总',
          requiresAuth: true,
        },
      },

      // ----------------------------------- 404页面 -----------------------------------

      // 404页面
      {
        path: '/:catchAll(.*)',
        // redirect: '/404',
        component: () => import('@/views/404.vue'),
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
];
